import { Box, Text } from "@chakra-ui/react";

type Props = {
  color?: string;
  value?: number;
  showValue?: boolean;
};
export const ScoreBox: React.FC<Props> = ({
  color = "transparent",
  value,
  showValue = false,
}) => {
  return (
    <Box bgColor={color} minWidth={12} height={5} borderRadius={4}>
      <Text textAlign="center" fontSize="sm" fontWeight="semibold">
        {showValue && value}
      </Text>
    </Box>
  );
};
